import React from "react";
import { motion } from "framer-motion";
import { Calendar, ArrowUpRight } from "lucide-react";
import { CALENDLY_URL, IMAGES } from "@/lib/site-data";

const BookCall = () => {
  return (
    <section
      id="book"
      data-testid="book-call-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="relative grid lg:grid-cols-12 gap-12 lg:gap-16 items-center bg-brand-cream rounded-[2.5rem] p-10 md:p-16 lg:p-20 overflow-hidden border border-brand-blue/10">
          {/* Decorative organic shape */}
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-brand-periwinkle/40 blur-3xl pointer-events-none" aria-hidden="true" />
          <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-brand-sage/20 blur-3xl pointer-events-none" aria-hidden="true" />

          <div className="relative lg:col-span-7">
            <p className="font-sans text-xs md:text-sm tracking-[0.25em] uppercase text-brand-sage mb-5">
              Ready when you are
            </p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-brand-ink">
              Let's build something{" "}
              <span className="italic text-brand-blue">rooted</span> together.
            </h2>
            <p className="mt-6 text-lg text-brand-ink/75 leading-relaxed max-w-xl">
              Book a free discovery call. We'll talk through what you're building,
              where you're stuck, and whether we're the right fit to roll up our
              sleeves alongside you.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href={CALENDLY_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="bookcall-primary-btn"
                className="group inline-flex items-center justify-center gap-2 bg-brand-blue text-brand-cream hover:bg-brand-ink transition-all duration-300 rounded-full px-8 py-4 font-sans font-medium text-base shadow-lg shadow-brand-blue/20 hover:shadow-xl hover:-translate-y-0.5"
              >
                <Calendar className="w-4 h-4" />
                Schedule a Discovery Call
                <ArrowUpRight className="w-4 h-4 group-hover:rotate-12 transition-transform" />
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
                }}
                data-testid="bookcall-secondary-btn"
                className="inline-flex items-center justify-center gap-2 bg-transparent text-brand-blue border border-brand-blue/40 hover:border-brand-blue hover:bg-white transition-all rounded-full px-8 py-4 font-sans font-medium text-base"
              >
                Or send us a message
              </a>
            </div>

            <p className="mt-6 text-sm text-brand-sage font-sans">
              ⏱ Replies within 2 business days · No commitment to start
            </p>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative lg:col-span-5"
          >
            <div className="relative aspect-square max-w-sm mx-auto">
              <div className="absolute -inset-3 bg-brand-blue rounded-[2rem] -rotate-2" aria-hidden="true" />
              <img
                src={IMAGES.diverseMeeting}
                alt="Diverse women leaders collaborating in a professional meeting"
                className="relative w-full h-full object-cover rounded-[2rem] shadow-xl rotate-1"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BookCall;
